module.exports = __webpack_public_path__ + "img/header-engagementRingsCollectionRings.21383e4.jpg";